module.exports = __webpack_public_path__ + "img/brand-cases26.9e8372dc.png";